import type { MutableRefObject } from "react";
import { createRef } from "react";

import type { MeasureInteractionPositions } from "./measureInteractions";

// Shared reference for measure interaction positions.
// Updated by the canvas and consumed by HTML interactions.
export const measureInteractionPositionsRef: MutableRefObject<MeasureInteractionPositions> =
    createRef() as MutableRefObject<MeasureInteractionPositions>;

measureInteractionPositionsRef.current = {
    remove: [],
    removeAxis: [],
    info: [],
    surfaceInfo: {},
};
